import { MessagingSettingsAction } from "./messaging.actions"
import { MessagingSettingsState } from "./messaging.state"
import { ChannelSettingsMessagingTypes } from "./messaging.types"

const defaultState: MessagingSettingsState = {
    messagingConfigs: {},
    messagingConfigsIsLoading: false,
    selectedMessagingConfig: undefined,
    pinpointNumbers: [],
    whatsappAccessCode: undefined
}

const messagingSettingsReducer = (
    state: MessagingSettingsState = defaultState,
    action: MessagingSettingsAction,
) => {
    switch (action.type) {
        case ChannelSettingsMessagingTypes.SET_MESSAGING_CONFIGS:
            return {
                ...state,
                messagingConfigs: action.payload,
            }
        case ChannelSettingsMessagingTypes.SET_MESSAGING_CONFIGS_LOADING:
            return {
                ...state,
                messagingConfigsIsLoading: action.payload,
            }
        case ChannelSettingsMessagingTypes.SET_SELECTED_MESSAGING_CONFIG:
            return {
                ...state,
                selectedMessagingConfig: action.payload,
            }
        case ChannelSettingsMessagingTypes.SET_MESSAGING_PINPOINT_NUMBERS:
            return {
                ...state,
                pinpointNumbers: action.payload
            }
        case ChannelSettingsMessagingTypes.SET_WHATSAPP_ACCESS_CODE:
            return {
                ...state,
                whatsappAccessCode: action.payload
            }
        default:
            return state
    }
}

export default messagingSettingsReducer
